import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsPlanInfoRoute: InvariantJiraRoute = {
	name: 'plan-settings-plan-info',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info',
};
